<template>
  <div
    class="container-fluid"
    style="background-color: #fff; overflow: hidden; padding-bottom: -10px"
  >
    <div class="page">
      <div class="left-box">
        <draggable v-model="itemList" class="list-group" handle=".handle">
          <ul class="ul-unstyled">
            <li
              class="list-group-item"
              v-for="(element, index) in itemList"
              :key="element.id"
            >
              <div class="handle">
                <aside class="seq">
                  {{ ++index }}
                </aside>
                <main class="item">
                  <Input
                    v-if="element.ColumnType === 'input'"
                    :data="element"
                    @addItem="addItem"
                    @delItem="delItem"
                  />
                  <Textarea
                    v-if="element.ColumnType === 'textarea'"
                    :data="element"
                    @addItem="addItem"
                    @delItem="delItem"
                  />
                </main>
              </div>
            </li>
          </ul>
        </draggable>
      </div>
      <div class="right-box">
        <div class="type-button-group">
          <button
            type="button"
            class="btn btn-outline-info btn-sm"
            @click="add({ type: '單行文字' })"
          >
            單行文字
          </button>
          <button
            type="button"
            class="btn btn-outline-info btn-sm"
            @click="add({ type: '多行文字' })"
          >
            多行文字
          </button>
          <button
            type="button"
            class="btn btn-sm"
            style="background: #3dba90; color: #fff"
            @click="viewExample"
          >
            預覽
          </button>
        </div>
      </div>
    </div>

    <div id="exampleModal" class="modal" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <perfect-scrollbar class="modal-body">
            <h4 class="mb-4" style="margin-left: 25px; color: #3dba90">
              <strong>問卷</strong>
            </h4>
            <div
              class="preview-content"
              v-for="(item, index) in itemList"
              :key="item.id"
            >
              <div class="preview-item">
                <strong>{{ ++index }}</strong>
              </div>
              <div class="preview-item flex-2">
                <div class="item-title">
                  <h5 style="margin-top: 5px">
                    <strong>{{ item.Title }}</strong
                    ><span v-if="item.require" class="mark">*</span>
                  </h5>
                  <p style="color: #bdbdbd; font-size: 14px">
                    {{ item.description }}
                  </p>
                </div>
                <div>
                  <input
                    v-if="item.type === 'input'"
                    class="preview-input"
                    type="text"
                  />
                  <textarea
                    v-if="item.type === 'textarea'"
                    rows="5"
                    class="preview-textarea"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div class="text-center mt-4 mb-4">
              <button
                type="button"
                class="btn btn-success"
                style="padding: 5px 40px"
              >
                送出
              </button>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import draggable from "vuedraggable";
import Input from "@/components/back/Survey/Input";
import Textarea from "@/components/back/Survey/Textarea";

let id = 0;

export default {
  name: "New",

  components: {
    draggable,
    Input,
    Textarea,
  },
  data() {
    return {
      itemList: [],
    };
  },
  methods: {
    viewExample() {
      const found = this.itemList.filter((element) => element.Title === null);
      if (found.length === 0) {
        $("#exampleModal").modal("show");
      } else {
        alert("尚有標題未填寫");
      }
    },
    add({ type }) {
      switch (type) {
        case "單行文字":
          this.itemList.push({
            ColumnType: "input",
            name: id + " 單行文字",
            id,
            Title: null,
          });
          break;
        case "多行文字":
          this.itemList.push({
            ColumnType: "textarea",
            name: id + " 多行文字",
            id,
            Title: null,
          });
          break;
      }
      id++;
    },
    addItem(e) {
      const dataIndex = this.itemList.findIndex((item) => item.id === e.id);
      this.itemList.splice(dataIndex, 1, { ...e });
    },
    delItem(e) {
      const dataIndex = this.itemList.findIndex((item) => item.id === e.id);
      this.itemList.splice(dataIndex, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  height: 0;
  .left-box {
    display: block;
    width: 80%;
    height: 88vh;
    overflow-y: auto;
    .ul-unstyled {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
    .seq {
      cursor: default;
      display: flex;
      float: 1 1 12%;
      margin-left: 6px;
    }
    .item {
      display: flex;
      flex-direction: column;
      float: 1 1 100%;
      margin: 0 15px;
    }
  }

  .right-box {
    display: flex;
    flex-direction: column;
    width: 20%;
    padding: 0 10px;
    .type-button-group {
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #f6f6f6;
    }
    button {
      border-style: dashed;
      margin: 0 40px 10px 40px;
    }
  }
}

.modal-body {
  padding: 30px;
}

.preview-content {
  display: flex;
  height: auto;
  padding: 15px 30px;
  .preview-item {
    flex: 0 0 5%;
    display: flex;
  }
  .flex-2 {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 85%;
    flex-direction: column;
  }
  .item-title {
    margin-bottom: 10px;
  }
  .preview-input {
    width: 100%;
    line-height: 1.6;
    border-top: none;
    border-right: none;
    border-bottom: 1px solid #bdbdbd;
    border-left: none;
    outline: none;
    box-shadow: none;
  }
  .preview-input:focus {
    border-bottom: 1px solid #000;
  }
  .preview-textarea {
    width: 100%;
    line-height: 1.6;
    border: 1px solid #bdbdbd;
    padding: 5px;
    outline: none;
    box-shadow: none;
    border-radius: 3px;
  }
  .preview-textarea:focus {
    border: 1px solid #000;
  }
}
</style>
